export default __webpack_public_path__ + "static/media/taima.86c10c6a.jpg";